import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainRemoteDoorOpen(ids) {
  return maintainRequest.get(
    `/device/maintenanceMan/accessDevice/remoteDoorOpen/${ids}`
  );
}
